import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Status } from '@nx-customer-apps/shared/enums';
import { StatusSummary } from '@nx-customer-apps/shared/interfaces';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';
import { MarkdownItPipe } from '../../pipes';

@Component({
    selector: 'vp-status-page',
    templateUrl: './status-page.component.html',
    styleUrls: ['./status-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, DatePipe, TranslatePipe, ComponentsModule, MarkdownItPipe]
})
export class StatusPageComponent {
    public readonly status = Status;
    @Input() statusSummary: StatusSummary | null;
    @Input() hasMaintenanceAccess: boolean = false;
}
